import { Injectable } from '@angular/core';
import { HttpService } from './httpService';
import { HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PortalService {

  constructor(private httpService: HttpService) { }

  async getIPAddress() {
    let ipAddress = "";
    if (sessionStorage.getItem('ipAddress') != null) {
      ipAddress = sessionStorage.getItem('ipAddress');
    } else {
      let options = {
      }
      let response: any = await this.httpService.sendGetRequest("https://api.ipify.org/?format=json", options);
      console.log("PortalService | getIPAddress => ", response ? JSON.stringify(response) : null);
      if (response) {
        ipAddress = response.ip;
        if (ipAddress) {
          sessionStorage.setItem('ipAddress', ipAddress);
        }
        console.log('IP ADDRESS FROM URL => ', sessionStorage.getItem('ipAddress'))
      };
    }
    return ipAddress;
  }

  async visitorLogEntryForLP() {
    let lpvisitorId = sessionStorage.getItem('lpvisitorId');
    if (lpvisitorId == null || lpvisitorId == "") {
      let msisdn = localStorage.getItem('msisdn');
      if (msisdn == null || msisdn == undefined || msisdn == "") {
        msisdn = "0";
      }
      let requestId = Number(new Date());
      let url = environment.serviceUrl + 'portal/landingvisitorlog' + "?requestId=" + requestId;
      let postData = {
        "data": {
          "msisdn": msisdn,
          "useragent": sessionStorage.getItem('userAgent') ?? "",
          "portal": environment.portal,
          "country": environment.country,
          "operator": environment.operator,
          "service": environment.service,
          "source": sessionStorage.getItem('source') ? sessionStorage.getItem('source') : "Portal",
          "referer": sessionStorage.getItem('referer') ?? "",
          "ip": sessionStorage.getItem('ipAddress') ?? "1.1.1.1",
          "pubid": sessionStorage.getItem('pubId') ?? "",
          "clickid": sessionStorage.getItem('clickId') ?? "",
          "consentid": '0',
        }
      }
      let options = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        })
      }
      let response = await this.httpService.sendPostRequest(url, postData, options);
      console.log("PortalService | visitorLogEntryForLP => ", response ? JSON.stringify(response) : null);
      if (response['success']) {
        let lpvisitorId = response['data'];
        console.log('lpvisitorId => ', lpvisitorId);
        if (lpvisitorId) {
          sessionStorage.setItem('lpvisitorId', lpvisitorId);
        }
      }
    }
  }

  async visitorLogEntryForPortal() {
    let visitorId = sessionStorage.getItem('visitorId');
    if (visitorId == null || visitorId == "") {
      let msisdn = localStorage.getItem('msisdn');
      if (msisdn == null || msisdn == undefined || msisdn == "") {
        msisdn = "0";
      }
      let requestId = Number(new Date());
      let url = environment.serviceUrl + 'portal/visitorlog' + "?requestId=" + requestId;

      let postData = {
        "data": {
          "msisdn": msisdn,
          "useragent": sessionStorage.getItem('userAgent') ?? "",
          "portal": environment.portal,
          "country": environment.country,
          "operator": environment.operator,
          "service": environment.service,
          "source": sessionStorage.getItem('source') ? sessionStorage.getItem('source') : "Portal",
          "referer": sessionStorage.getItem('referer') ?? "",
          "ip": sessionStorage.getItem('ipAddress') ?? "1.1.1.1",
          "lpvisitorid": parseInt(sessionStorage.getItem('lpvisitorId')) ? parseInt(sessionStorage.getItem('lpvisitorId')) : 0,
          "consentid": '0',
        }
      }
      let options = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        })
      }
      let response = await this.httpService.sendPostRequest(url, postData, options);
      console.log("PortalService | visitorLogEntryForPortal => ", response ? JSON.stringify(response) : null);
      if (response['success']) {
        let visitorId = response['data'];
        console.log('visitorId => ', visitorId);
        if (visitorId) {
          sessionStorage.setItem('visitorId', visitorId);
        }
      }
    }
  }

  async downloadLogEntry(contentName) {
    let msisdn = localStorage.getItem('msisdn');
    let requestId = Number(new Date());
    if (msisdn == null || msisdn == undefined || msisdn == "") {
      msisdn = "0";
    }
    let url = environment.serviceUrl + 'portal/downloadlog' + "?requestId=" + requestId;;
    let postData = {
      "data": {
        "msisdn": msisdn,
        "useragent": sessionStorage.getItem('userAgent') ?? "",
        "portal": environment.portal,
        "country": environment.country,
        "operator": environment.operator,
        "service": environment.service,
        "source": sessionStorage.getItem('source') ?? "",
        "contentid": "0",
        "contentname": contentName,
        "visitorid": parseInt(sessionStorage.getItem('visitorId')) ? parseInt(sessionStorage.getItem('visitorId')) : 0,
        "ip": sessionStorage.getItem('ipAddress') ?? "1.1.1.1",
        "pubid": sessionStorage.getItem('pubId') ?? "",
        "clickid": sessionStorage.getItem('clickId') ?? "",
      }
    }
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    }
    let response = await this.httpService.sendPostRequest(url, postData, options);
    console.log("PortalService | downloadLogEntry => ", response ? JSON.stringify(response) : null);
  }



}
